import { BaseIcon, IconProps } from './base';

export function IconBrandAvia(props: IconProps) {
  return (
    <BaseIcon size={40} {...props} viewBox="0 0 40 40">
      <rect x="0.0546875" width="40" height="40" rx="2" fill="#013BCD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.0631 11.3191L15.7845 11.3191L9.9834 28.749L23.7605 28.749L30.0631 11.3191ZM21.3018 12.839H18.2617V27.271H21.3018V12.839Z"
        fill="white"
      />
    </BaseIcon>
  );
}
